<template>
  <div>
    <b-row>
      <div class="col-12 my-2">
        <b class="float-left"
          ><i class="fas fa-tasks"></i> {{ $lang.azmoonLang.azmoon_execute }} :
          {{ examPack.exam_pack_name }}
        </b>
        <span class="float-right" v-if="examPack.duration > 0"
          ><b>{{ $lang.azmoonLang.azmoon_duration }}</b> :
          {{ examPack.duration }} {{ $lang.azmoonLang.minute }}</span
        >
      </div>
      <div v-if="examPack.exam_pack_description" class="col-12 my-2">
        <p v-html="createPureDom(examPack.exam_pack_description)"></p>
      </div>
    </b-row>

    <div v-for="(item, key) in question_items" :key="key">
      <b-card
        v-if="
          ((examPack.display_mode && examPack.display_mode.id) ||
            (item.question_info &&
              item.question_info.display_mode &&
              item.question_info.display_mode.id)) == 1
        "
        class="card card-question_black my-1"
      >
        <div slot="header">
          <h6 class="d-flex m-0" v-if="examPack.hidden_question_title == 0">
            <span>
              {{
                item.question_info && item.question_info.question_number
              }})</span
            >
            <div
              class="title_description mx-1"
              v-html="titleQuestion(item.question_info)"
            ></div>
          </h6>
          <h6 v-if="examPack.hidden_question_title == 1">
            {{ $lang.azmoonLang.question_number }}
            {{ item.question_info.question_refrence_number }}
          </h6>
        </div>
        <div
          :class="
            (examPack.display_style && examPack.display_style.id == 1) ||
            (examPack.display_style && examPack.display_style.id == 3) ||
            (item.question_info &&
              item.question_info.display_style &&
              item.question_info.display_style.id == 1) ||
            (item.question_info &&
              item.question_info.display_style &&
              item.question_info.display_style.id == 3)
              ? `row`
              : ``
          "
        >
          <optionchecked
            :item="item && item.question_info"
            v-for="(option, index) in item.question_info &&
            item.question_info.options"
            :key="index"
            :option="option"
            :col_number="
              examPack.display_count ||
              (item.question_info && item.question_info.display_count)
            "
            :option_show_kind="
              (examPack.option_show_kind && examPack.option_show_kind.id) ||
              (item.question_info &&
                item.question_info.option_show_kind &&
                item.question_info.option_show_kind.id)
            "
            :display_style="
              (examPack.display_style && examPack.display_style.id) ||
              (item.question_info &&
                item.question_info.display_style &&
                item.question_info.display_style.id)
            "
            :itemId="item.question_info && item.question_info.id"
            @optionChecked="answeQuestion"
            :answer="item.question_info && item.question_info.person_answer"
            ref="questionRef"
          />
          <div
            v-if="
              (item.question_info &&
                item.question_info.question_kind.id == 2) ||
              (item.question_info && item.question_info.question_kind.id == 3)
            "
          >
            <b-form-input
              v-if="
                item.question_info && item.question_info.question_kind.id == 2
              "
              v-model="item.question_info.person_answer"
            ></b-form-input>
            <b-form-textarea
              v-if="
                item.question_info && item.question_info.question_kind.id == 3
              "
              v-model="item.question_info.person_answer"
            >
            </b-form-textarea>
            <div class="float-right my-2">
              <b-button
                variant="success"
                @click="
                  answeQuestion(
                    item,
                    item.question_info,
                    item.question_info && item.question_info.id
                  )
                "
                :disabled="item.loader"
              >
                <div v-if="!item.loader">
                  {{ $lang.azmoonLang.submitButton }}
                  <i class="fa fa-check"></i>
                </div>
                <div v-if="item.loader">
                  <b-spinner small></b-spinner>
                  {{ $lang.azmoonLang.textLoding }}
                </div>
              </b-button>
            </div>
          </div>
        </div>
      </b-card>

      <lineOption
        v-if="
          ((examPack.display_mode && examPack.display_mode.id) ||
            (item.question_info &&
              item.question_info.display_mode &&
              item.question_info.display_mode.id)) == 2
        "
        :hiddenQuestionTitle="examPack && examPack.hidden_question_title"
        :title="
          item.question_info &&
          item.question_info.title &&
          item.question_info.title.title_description
        "
        :person_answer="item.question_info && item.question_info.person_answer"
        :item="item && item.question_info"
        :id="item.question_info.id"
        :options="item.question_info && item.question_info.options"
        :option_description="
          item.option_selected && item.option_selected.option_description
        "
        :option_show_kind="
          (examPack.option_show_kind && examPack.option_show_kind.id) ||
          (item.question_info &&
            item.question_info.option_show_kind &&
            item.question_info.option_show_kind.id)
        "
        @answeQuestion="answeQuestion"
        :questionOrder="item.question_order"
      />
    </div>

    <paganationSearch
      class="mt-1"
      :allowPaginate="allowPaginate"
      :total="totalRows"
      :total_pages="totalPages"
      :perPage="perPage"
      v-model="page"
      @input="paging"
    />
  </div>
</template>

<script>
import { createPureDom } from "@/shared/utils";
import optionchecked from "./../preview/optionchecked";
import lineOption from "./../preview/lineOption";
import paganationSearch from "@/components/base/paganationSearch";
export default {
  components: {
    optionchecked,
    lineOption,
    paganationSearch,
  },
  props: {
    examPack: {
      type: Object,
      default: () => {},
    },
  },
  inject: ["examPackQuestionRepository"],
  data() {
    return {
      // examPack_question_url: this.$config.api_url + this.$config.azmoon.examPack_question.replace("{0}", this.$route.params.id),
      question_items: [],
      allowPaginate: true,
      totalRows: 0,
      totalPages: 0,
      perPage: 0,
      page: 1,
    };
  },
  methods: {
    createPureDom,
    titleQuestion(item) {
      return ` ${
        item && item.title
          ? this.createPureDom(item.title.title_description)
          : ` `
      } `;
    },
    async answeQuestion(item, option, itemId) {
      let itemSelected = this.question_items.find(
        (x) => x.question_info.id == itemId
      );
      itemSelected.question_info.person_answer = option.option_number;
      itemSelected.option_selected = option;
      itemSelected.question_info.answer_number = option.option_number;

      this.question_items.map((x) => {
        let options;
        if (x.question_info.id == itemId) {
          options = x.question_info.options.map((optionItem) => {
            if (optionItem.id == option.id) {
              return {
                ...optionItem,
                answer: true,
              };
            } else {
              return {
                ...optionItem,
                answer: false,
              };
            }
          });
          return {
            ...x,
            ...(x.question_info.options = options),
          };
        }
      });
    },
    paging(page) {
      this.page = page;
      this.getQuestions();
    },
    async getQuestions() {
      let params = {
        per_page: this.examPack.question_per_page,
        page: this.page,
      };
      try {
        //   this.isOverlay = true
        const response_questions = await this.examPackQuestionRepository.list(
          this.$route.params.id,
          params
        );
        let data_questions = response_questions.data.data.result;
        let data = response_questions.data.data;

        this.totalRows = data.total;
        this.totalPages = data.total_pages;
        this.perPage = data.per_page;
        this.question_items = data_questions;
      } catch (error) {
        this.$generateError(error);
      } finally {
        //   this.isOverlay = false
      }
    },
  },
  created() {
    this.getQuestions();
  },
};
</script>

<style></style>
